import {
  Animated,
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import React, {useEffect} from 'react';

import {Portal} from '@gorhom/portal';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface Props {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const slideAnim = new Animated.Value(0);

const BottomSheet = ({open, onClose, children}: Props) => {
  const theme = useColorThemeType();
  useEffect(() => {
    Animated.timing(slideAnim, {
      toValue: open ? 1 : 0,
      duration: 240,
      useNativeDriver: true,
    }).start();
  }, [open]);

  if (!open) return null;

  const translateY = slideAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [500, 0],
  });

  return (
    <Portal>
      <View style={styles.backdrop}>
        <TouchableOpacity style={StyleSheet.absoluteFill} onPress={onClose} />

        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          keyboardVerticalOffset={Platform.OS === 'ios' ? 90 : 0}>
          <Animated.View
            style={[
              styles.container,
              {
                transform: [{translateY}],
                backgroundColor: theme?.background.white[100],
              },
            ]}>
            {children}
          </Animated.View>
        </KeyboardAvoidingView>
      </View>
    </Portal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: 'flex-end',
  },
  container: {
    paddingTop: 12,
    paddingBottom: 10,
    paddingHorizontal: 16,
    borderTopLeftRadius: 18,
    borderTopRightRadius: 18,
    maxHeight: '100%',
  },
});

export default BottomSheet;
